export default {
  submissions: [],
  pagination: {},
}
